import { render, staticRenderFns } from "./StoperNumbers.vue?vue&type=template&id=1dcc74ca&scoped=true&"
import script from "./StoperNumbers.vue?vue&type=script&lang=js&"
export * from "./StoperNumbers.vue?vue&type=script&lang=js&"
import style0 from "./StoperNumbers.vue?vue&type=style&index=0&id=1dcc74ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc74ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dcc74ca')) {
      api.createRecord('1dcc74ca', component.options)
    } else {
      api.reload('1dcc74ca', component.options)
    }
    module.hot.accept("./StoperNumbers.vue?vue&type=template&id=1dcc74ca&scoped=true&", function () {
      api.rerender('1dcc74ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StoperNumbers.vue"
export default component.exports